import { Container } from "@mui/material";
import MyAppBar from "@components/organisms/MyAppBar/MyAppBar";
import GlobalAlertProvider from "../providers/GlobalAlertProvider";
import { Outlet } from "react-router-dom";
const MainLayout = () => {
  return <>
      <MyAppBar />
      <Container maxWidth={"xl"} sx={{
      position: "relative",
      overflowX: "hidden",
      marginY: 3,
      marginBottom: 10
    }}>
        <GlobalAlertProvider>
          <Outlet />
        </GlobalAlertProvider>
      </Container>
    </>;
};
export default MainLayout;